import React, { useCallback, useState } from 'react';
import './video-player.scss';
import { Loader, LoaderSize } from '../loader/loader';

interface VideoPlayerProps {
  video?: string;
}

export const VideoPlayer = (props: VideoPlayerProps) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoad = useCallback(() => setIsLoading(false), [setIsLoading]);

  return props.video ? (
    <div className='video-player-container'>
      {isLoading && (
        <div className='loader-container'>
          <Loader loadersize={LoaderSize.M} />
        </div>
      )}
      <video
        className='video-player-iframe'
        controls
        controlsList='nodownload'
        autoPlay={false}
        muted
        onLoadedMetadata={handleLoad}
        onError={() => setIsLoading(false)}
        onCanPlay={handleLoad}>
        <source src={props.video} type='video/mp4' />
        Your browser does not support the video tag.
      </video>
    </div>
  ) : (
    <></>
  );
};
